"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var systemConfigApi = _interopRequireWildcard(require("@/api/systemConfig.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: 'Vue Element Admin',
      siteLogoLeftTop: '',
      //左上角logo大
      siteLogoSquare: '' //左上角logo小
    };
  },
  mounted: function mounted() {
    this.getLogo();
  },
  methods: {
    //获取左上角菜单logo
    getLogo: function getLogo() {
      var _this = this;
      systemConfigApi.getSiteLogoApi().then(function (data) {
        _this.siteLogoLeftTop = data.siteLogoLeftTop;
        _this.siteLogoSquare = data.siteLogoSquare;
      });
    }
  }
};